export const LOCALSTORAGE_USER = 'telgani-dash';
export const LOCALSTORAGE_LNG = 'telgani-lng';

export const EN = 'en';
export const AR = 'ar';

export const LANGUAGES = [EN, AR];

export const DIRECTIONS = {
	LTR: 'ltr',
	RTL: 'rtl'
};

export const countryPhoneNumbers = [
	{ name: 'sa', value: '+966' },
	{ name: 'ae', value: '+971' },
	{ name: 'bh', value: '+973' },
	{ name: 'kw', value: '+965' },
	{ name: 'om', value: '+968' },
	{ name: 'cn', value: '+86' },
	{ name: 'eg', value: '+20' },
	{ name: 'fr', value: '+33' },
	{ name: 'de', value: '+49' },
	{ name: 'gb', value: '+44' },
	{ name: 'gr', value: '+30' },
	{ name: 'in', value: '+91' },
	{ name: 'id', value: '+62' },
	{ name: 'jp', value: '+81' },
	{ name: 'jo', value: '+962' },
	{ name: 'ke', value: '+254' },
	{ name: 'my', value: '+60' },
	{ name: 'ph', value: '+63' },
	{ name: 'pl', value: '+48' },
	{ name: 'ru', value: '+7' },
	{ name: 'za', value: '+27' },
	{ name: 'ch', value: '+41' },
	{ name: 'tz', value: '+255' },
	{ name: 'tr', value: '+90' },
	{ name: 'us', value: '+1' }
];

export const defaultPhoneNumber = countryPhoneNumbers.find(
	(value) => value.name === 'sa'
);

export const convertApiFormErrors = (errors) =>
	Object.keys(errors).reduce((acc, next) => {
		if (next.includes('.')) {
			const [section, field] = next.split('.');
			acc[section] = { [field]: errors[next][0] };
		} else {
			acc[next] = errors[next][0];
		}
		return acc;
	}, {});
